import { inject, Injectable } from '@angular/core';

import { WINDOW } from 'app/providers/window.provider';

import { CreateReportHostToolService } from './create-report-host-tool.service';
import { HostToolsProvider } from './host-tool.model';
import { NavigationHostToolService } from './navigation-host-tool.service';

/** Single point of contact with `window.CelesteSDK` for registering host tools. */
@Injectable({
  providedIn: 'root',
})
export class HostToolsService {
  private readonly window = inject<Window>(WINDOW);
  private readonly providers: HostToolsProvider[] = [
    inject(NavigationHostToolService),
    inject(CreateReportHostToolService),
  ];

  public registerAll(): void {
    const tools = this.providers.map((provider) => provider.getTool());

    this.window.CelesteSDK?.registerHostTools(tools);
  }
}
